export * from './baSystemPicture.pipe';
